export default __webpack_public_path__ + "04277a799cb3f1b29dfad816139bad03.svg";